import React from 'react';
import { demoPages, administrationSite } from '../menu';
import DefaultAside from '../pages/_layout/_asides/DefaultAside';

const asides = [
	{ path: demoPages.login.path, element: null, exact: true },
	{ path: demoPages.register.path, element: null, exact: true },
	{ path: demoPages.resetPassword.path, element: null, exact: true },
	{ path: demoPages.verifyAccount.path, element: null, exact: true },
	{ path: '*', element: <DefaultAside />, exact: true },
];

export default asides;
